import { Link } from 'react-router-dom';
import { categoryMeta, type MediaType } from '@/mocks/catalog';

const order: MediaType[] = ['movie', 'tv', 'show'];

const extra = [
  { label: '影视资讯', desc: '影评、行业观察与活动公告', icon: 'ri-newspaper-line', to: '/news' },
];

export default function CategoryQuickAccess() {
  return (
    <section className="w-full bg-background-50 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto w-full max-w-[1400px]">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-600">Explore Channels</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">快速进入频道</h2>
          </div>
          <p className="max-w-md text-sm text-foreground-500">三大内容频道覆盖电影、剧集与综艺，按类型、地区和年份精细筛选。</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {order.map((type) => {
            const meta = categoryMeta[type];
            return (
              <Link
                key={type}
                to={`/category/${type}`}
                className="group relative flex h-[190px] flex-col justify-end overflow-hidden rounded-lg"
              >
                <img
                  src={meta.cover}
                  alt={`${meta.name} 分类封面`}
                  title={`${meta.name} - ${meta.desc}`}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/10"></div>
                <div className="relative p-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                    <i className={`${meta.icon} text-base`}></i>
                  </span>
                  <h3 className="mt-2.5 font-display text-lg font-bold text-white">{meta.name}</h3>
                  <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-white/75">{meta.desc}</p>
                  <span className="mt-2 inline-flex items-center gap-1 font-label text-[11px] uppercase tracking-wider text-accent-300">
                    进入频道 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}

          {extra.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="group flex h-[190px] flex-col justify-between rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-950 text-accent-400">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div>
                <h3 className="font-display text-lg font-bold text-foreground-950">{item.label}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 font-label text-[11px] uppercase tracking-wider text-accent-700">
                  阅读更多 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}